import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, CalenderHeading } from "../../../Constants/Constants";
import { Fragment } from "react/jsx-runtime";
import DragCalendar from "./DragCalendar/DragCalendar";

const CalendarContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={CalenderHeading} parent={Apps} />
      <Container fluid className="calendar-basic">
        <Card>
          <CardBody>
            <Row>
              <Col sm="12">
                <Row>
                  <DragCalendar />
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default CalendarContainer;
